import { Tabs, TabsProps } from "antd";
import { TabLabel } from "./TabLabel";
import styles from "./customTabs.module.css";

export interface CustomTabItem {
  key: string;
  title: string;
  count?: number;
  children: React.ReactNode;
}

interface CustomTabsProps extends Omit<TabsProps, "items"> {
  items: CustomTabItem[];
}

export const CustomTabs = ({ items, ...props }: CustomTabsProps) => {
  const formattedItems = items.map((item) => ({
    key: item.key,
    label: <TabLabel title={item.title} count={item.count} />,
    children: item.children,
  }));

  const renderTabBar = (props: any, DefaultTabBar: any) => <DefaultTabBar {...props} className={styles.customTabBar} />;

  return <Tabs items={formattedItems} renderTabBar={renderTabBar} {...props} />;
};
